"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useItemsMutators = exports.useItemsAccessors = void 0;

var uuid_1 = require("uuid");

var core_1 = require("@bodiless/core");
/**
 * Returns a pair of functions which can be used to get or set
 * the items in the component's ContentNode.
 */


exports.useItemsAccessors = function () {
  var node = core_1.useNode().node;
  return {
    // We provide a default element for top level lists.
    getItems: function getItems() {
      return node.data.items || ['default'];
    },
    setItems: function setItems(items) {
      return node.setData(__assign(__assign({}, node.data), {
        items: items
      }));
    },
    deleteSubnode: function deleteSubnode(item) {
      var path$ = item ? node.path.concat(item) : node.path;
      return node.delete(path$);
    }
  };
};
/**
 * Returns a method which can be used to delete an item, or call
 * an "unwrap" handler if there is only one item in the list.
 */


var useDeleteItem = function useDeleteItem(_a) {
  var unwrap = _a.unwrap,
      onDelete = _a.onDelete;

  var _b = exports.useItemsAccessors(),
      getItems = _b.getItems,
      setItems = _b.setItems,
      deleteSubnode = _b.deleteSubnode;

  return function (item) {
    var items = getItems().filter(function (item$) {
      return item$ !== item;
    });
    setItems(items);
    deleteSubnode(item);

    if (onDelete) {
      onDelete(item);
    }

    if (items.length === 0 && unwrap) {
      unwrap();
    }
  };
};
/**
 * Returns a method which can be used to delete a sublist
 */


var useDeleteSublist = function useDeleteSublist() {
  var deleteSubnode = exports.useItemsAccessors().deleteSubnode;
  return function () {
    return deleteSubnode('sublist');
  };
};
/**
 * Returns a method which can be used to add an item after the specified
 * item.
 */


var useAddItem = function useAddItem() {
  var _a = exports.useItemsAccessors(),
      getItems = _a.getItems,
      setItems = _a.setItems;

  return function (item) {
    var items = getItems();
    var index = items.findIndex(function (item$) {
      return item$ === item;
    });

    var newItems = __spreadArrays(items.slice(0, index + 1), [uuid_1.v4()], items.slice(index + 1));

    setItems(newItems);
  };
};
/**
 * Returns a pair of functions which can be used to insert
 * or delete items.
 */


exports.useItemsMutators = function (props) {
  return {
    addItem: useAddItem(),
    deleteItem: useDeleteItem(props || {
      unwrap: undefined,
      onDelete: undefined
    }),
    deleteSublist: useDeleteSublist()
  };
};